<script>
import RecycleModal from './RecycleModal.vue'
import FailModal from './FailModal.vue'
import moment from 'moment'

export default {
    components: {
        RecycleModal,
        FailModal
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        logs: {
            type: Object,
            required: false
        },
    },

    data() {
        return {
            fail_reason: '',
            passBtnDisabled: false,
            killer_question_status: this.jobApplication.killer_question_status,
        }
    },

    methods: {
        isChecked(answerId) {
            return this.jobApplication.user.killer_question_answers.filter(answer => answer.id == answerId).length == 1
        },
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
        fail(fail_reason) {
            this.fail_reason = fail_reason
            this.$nextTick(() => {
                this.$refs.failedButton.click();
            });
        },
        disablePassBtn() {
            this.passBtnDisabled = true;
            this.killer_question_status = 'passed';
        },
        convertDate(date, format = 'YYYY-MM-DD HH:mm') {
            return moment.parseZone(date).format(format)
        },
    },

    mounted() {
        if (this.jobApplication.killer_question_status == 'passed') {
            this.passBtnDisabled = true;
        }
    },

    watch: {
        //watch jobApplication deep true
        jobApplication: {
            handler: function (newVal, oldVal) {
                this.passBtnDisabled = false;
                if (newVal.killer_question_status == 'passed') {
                    this.passBtnDisabled = true;
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
@import './assets/scss/frontend/base/colour_vars.scss';

.bg-custom-green {
    background: $mycalling-green;
    color: white;
}
.font-small {
    font-size: .9rem !important;
}
</style>

<template>
    <div class="p-2">
        <form method="POST" v-on:submit="disablePassBtn">
            <input type="hidden" name="_csrfToken" :value="csrfToken" />
            <input type="hidden" name="fail_reason" :value="fail_reason" />
            <input type="hidden" name="killer_question_status" :value="killer_question_status">

            <div class="form-control border-0">
                <div v-for="(killerQuestion, index) in jobApplication.job.requisition.person_specification.killer_questions" class="mb-4 font-small" :key="`killer-question-${killerQuestion.id}`">
                    <span style="margin-right: 8px; color: #455666"><strong class="quesiton-title">{{ (index+1) }}. {{ killerQuestion.title }}</strong></span>
                    <template v-for="answer in killerQuestion.killer_question_answers">
                        <span 
                            v-if="isChecked(answer.id)"
                            :class="(answer.is_correct) ? 'badge-killer-question success' :'badge-killer-question fail'"
                            :key="`anwswer-status-${answer.id}`"
                        >{{ (answer.is_correct) ? 'PASS' : 'FAIL' }}</span>
                        <div v-if="isChecked(answer.id)" :key="`answer-title-${answer.id}`" class="mt-2" style="font-size: .9rem">
                            {{ answer.title }}
                        </div>
                        <input style="display:none" :disabled="true" :key="`killer-question-answe-${answer.id}`" type="radio" :id="`killer-question-answers-${answer.id}`" :checked="isChecked(answer.id)"/>
                    </template>
                </div>
            
                
                <hr style="max-width: unset;" />
                <strong class="mr-3 text-uppercase">Final Status: </strong>
                <span class="badge-killer-question"
                      :class="[(jobApplication.killer_question_status==='passed') ? 'bg-custom-green' : '',
                               (jobApplication.killer_question_status==='failed') ? 'fail' : '' ]">
                    {{ jobApplication.killer_question_status }}
                </span>
                <span class="text-uppercase" v-if="logs !== null && logs !== ''">
                    &nbsp;(UPDATED BY {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created) }})
                </span>
                <hr style="max-width: unset;" />
                

                <div class="grid-x grid-padding-x">
                    <div>
                        <button class="button px-5" type="submit" :disabled="passBtnDisabled">PASS</button>
                    </div>
                    <div class="cell shrink">
                        <button class="d-none" value="failed" ref="failedButton" name="killer_question_status"></button>
                        <button class="button alert px-5" type="button" @click="toggleModal('failModal')">FAIL</button>
                    </div>
                    <div>
                        <button class="button recycle px-5" type="button" @click="toggleModal('recycleModal')">RECYCLE</button>
                    </div>
                </div>
            </div>
        </form>

        <recycle-modal ref="recycleModal" :job-application="jobApplication" :csrf-token="csrfToken" />
        <fail-modal ref="failModal" :job-application="jobApplication" @submit="fail" />
    </div>
</template>